import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import '../../../Style/Style.css'

import {useThemeMode} from '../../../../../../_metronic/partials'
import {useNavigate} from 'react-router-dom'

import * as Yup from 'yup'
import {useFormik} from 'formik'
import {DataPruebaVehiculo} from '../../../../accounts/components/settings/SettingsModel'
import {ContactenosModel, DataFilterModel, RegistroEstatus, RegistroOrgVentas, RegistroOrgVentasxLocales} from '../../../models/_models'
import Swal from 'sweetalert2'
import {createContactenos, createReclamaciones, findAllEstatus, findAllOrgVByLocal, findAllOrgVentas} from '../../../models/_requests'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../auth'
import { convertToISODateString, DateFormat } from '../../../models/helpers'

const initialValues: ContactenosModel = {
  Nombres: '',
  Apellidos: '',
  Celular: '',
  Email: '',
  Mensaje: '',
  IdEstatus: 0,
  IdOrgV: '',
  Activo: false,
}

const contactenosSchema = Yup.object().shape({
  Nombres: Yup.string().max(50, 'Maximo 50 caracteres').required('nombre es requerido'),
  Apellidos: Yup.string().max(240, 'Maximo 240 caracteres').required('apellido es requerido'),
  Telefono: Yup.string()
    .matches(/^\d+$/, 'El celular debe contener solo dígitos') // Asegura que sean solo dígitos
    .max(12, 'El celular debe tener como máximo 12 dígitos') // Permite un máximo de 12 caracteres
    .required('Celular es requerido'),
  Email: Yup.string()
    .email('Debe ser un Email válido') // Valida que sea un email correcto
    .required('Email es requerido'),
  TipoDocumento: Yup.string().required('tipo de documento es requerido'),
  NumDocumento: Yup.string()
    .max(8, 'Maximo 8 caracteres')
    .required('número de documento es requerido'),
  Direccion: Yup.string().required('direccion es requerido'),
  Ciudad: Yup.string().required('ciudad es requerido'),
  Pais: Yup.string().required('pais es requerido'),
  TipoReclamo: Yup.string().required('tipo de reclamo es requerido'),
  FechaIncidencia: Yup.string().required('fecha de incidencia es requerido'),
  Detalle: Yup.string().required('detalle es requerido'),
  Pedido: Yup.string().required('pedido es requerido'),
  TipoBienContratado: Yup.string().required('tipo de bien contratado es requerido'),
  PadreOMadre: Yup.string().required('padre o madre es requerido'),
  MontoReclamo: Yup.string().required('monto es requerido'),
  Descripcion: Yup.string().required('descripcion es requerido'),
  FechaRespuesta: Yup.string().optional(),
  RespuestaAcciones: Yup.string().optional(),
  IdOrgVxLocal: Yup.number().moreThan(0, 'Local es requerido').required('Local es requerido'),
  IdEstatus: Yup.number().moreThan(0, 'estatus es requerido').required('estatus es requerido'),
  Activo: Yup.boolean().required('activo es requerido'),
})

const CreateReclamaciones: React.FC = () => {
  const {mode} = useThemeMode()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const intl = useIntl()

  const [estado, setEstado] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [loadingButton, setLoadingButton] = useState(false)

  const dataTipoDocumento= [
    {id: 'DNI', descripcion: 'DNI'},
    {id: 'Carnet de Extranjería', descripcion: 'Carnet de Extranjería'},
  ]

  const dataTipoBienContratado = [
    {id: 'producto', descripcion: 'Producto'},
    {id: 'servicio', descripcion: 'Servicio'},
  ]

  const dataTipoReclamo = [
    {id: 'reclamo', descripcion: 'Reclamo'},
    {id: 'queja', descripcion: 'Queja'},
  ]


  const [dataEstatus, setDataEstatus] = useState<RegistroEstatus[]>([])
  const getDataEstatus = async () => {
    const value = {
      cantidad_max: '0',
      Language: intl.locale.toUpperCase(),
      filters: [
        {
          campo: 'IdEsquemaEstatus',
          operador: 'EQ',
          tipo: 'string',
          valor1: '2',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllEstatus(value)
      if (list.message.msgId == 0) {
        setDataEstatus(list.registro)
      } else {
        setDataEstatus([])
      }
    } catch (error) {
      console.error(error)
    }
  }

 
  const [dataOrgVXLocal, setDataOrgVXLocal] = useState<RegistroOrgVentasxLocales[]>([])  
  const getOrgVXLocal = async() => {
          const body = {
            IdOrgV: currentUser ? currentUser.registro.IdOrgV : '',
        }
  
        try {
          const {data: org} = await findAllOrgVByLocal(body)
          if (org.message.msgId == 0) {
        
            setDataOrgVXLocal(org.registro)
          } else {
            setDataOrgVXLocal([])
          }
        } catch (error) {
          console.error(error)
        }
    }

  const formik = useFormik({
    initialValues: {
      Nombres: '',
      Apellidos: '',
      TipoDocumento:'',
      NumDocumento: '',
      Direccion: '',
      Ciudad: '',
      Pais: '',
      TipoReclamo: '',
      FechaIncidencia: '',
      Detalle: '',
      Pedido: '',
      TipoBienContratado: '',
      PadreOMadre: '',
      MontoReclamo: '',
      Descripcion: '',
      FechaRespuesta: '',
      RespuestaAcciones: '',
      IdOrgVxLocal: 0,
      Telefono: '',
      Email: '',
    //   Mensaje: '',
      IdEstatus: 0,
    //   IdOrgV: currentUser ? currentUser.registro.IdOrgV : '',
      Activo: false,
    },
    validationSchema: contactenosSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoadingButton(true)
      setLoading(true)
      try {
        console.log(JSON.stringify(values,null,2))
        const {data: create} = await createReclamaciones(
          values.Nombres,
          values.Apellidos,
          values.Email,
          values.Telefono,
          values.TipoDocumento,
          values.NumDocumento,
          values.Direccion,
          values.Ciudad,
          values.Pais,
          values.TipoReclamo,
          values.FechaIncidencia.trim().length > 0
                      ? convertToISODateString(values.FechaIncidencia)
                      : '', 
          values.Detalle,
          values.Pedido,
          values.TipoBienContratado,
          values.PadreOMadre,
          Number(values.MontoReclamo),
          values.Descripcion,
          values.FechaRespuesta.trim().length > 0
                      ? convertToISODateString(values.FechaRespuesta)
                      : '',
          values.RespuestaAcciones,
          Number(values.IdEstatus),
          Number(values.IdOrgVxLocal),
          values.Activo
        )

        if (create.message.msgId == 0) {
          Swal.fire({
            icon: 'success',
            title: 'Creado!',
            text: `${create.message.msgTxt}`,

            showConfirmButton: false,
            timer: 3000,
          })

          setTimeout(() => {
            const direccion = `/menu/administracion/reclamaciones/view`
            navigate(direccion, {
              state: {
                id_reclamo: create.registro.IdReclamo,
              },
            })
          },1000)
        
        }

        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops... Ocurrio un error',
            text: `${create.message.msgTxt}`,
            showConfirmButton: false,
            timer: 3000,
          })
        }
      } 
      catch (error) {
      console.error(error)  
      setSubmitting(false)
      setLoading(false)  
    }
      setLoadingButton(false)
    },
  })

  const handleCancelar = () => {
    setEstado(false)

    setTimeout(() => {
      const direccion = `/menu/administracion/reclamaciones`
      navigate(direccion)
    }, 1000)
  }

  useEffect(() => {
    getDataEstatus()
    getOrgVXLocal()
  }, [])

  return (
    <div className={'card'}>
      <form
        onSubmit={formik.handleSubmit}
        noValidate
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      >
        <div className='row g-2 g-xl-8 '>
          <div className='col-xl-12 '>
            <div className='card-body d-flex flex-column  pt-3 mt-15 pb-0'>
              <h3 className='card-title fs-1  flex-column text-center'>
                {intl.formatMessage({id: 'CONTACTUS_DATA'})}
              </h3>

              <div className='row mb-1'>
                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Nombres</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Nombres'
                      {...formik.getFieldProps('Nombres')}
                    />
                    {formik.touched.Nombres && formik.errors.Nombres && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Nombres}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Apellidos</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Apellidos'
                      {...formik.getFieldProps('Apellidos')}
                    />
                    {formik.touched.Apellidos && formik.errors.Apellidos && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Apellidos}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Email</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='email'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Email'
                      {...formik.getFieldProps('Email')}
                    />
                    {formik.touched.Email && formik.errors.Email && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Email}</div>
                      </div>
                    )}
                  </div>
                </div>

                    <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Teléfono</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='tel'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Teléfono'
                      {...formik.getFieldProps('Telefono')}
                    />
                    {formik.touched.Telefono && formik.errors.Telefono && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Telefono}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Estatus</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('IdEstatus')}
                    >
                      <option value={''}>Seleccione estatus...</option>
                      {dataEstatus.map((option) => (
                        <option key={option.IdEstatus} value={option.IdEstatus}>
                          {option.Descripcion}
                        </option>
                      ))}
                    </select>
                    {formik.touched.IdEstatus && formik.errors.IdEstatus && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.IdEstatus}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Sedes</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('IdOrgVxLocal')}
                    >
                      <option value={''}>Seleccione sede...</option>
                      {dataOrgVXLocal.map((option) => (
                        <option key={option.IdOrgVxLocal} value={option.IdOrgVxLocal}>
                          {option.Sede}
                        </option>
                      ))}
                    </select>
                    {formik.touched.IdOrgVxLocal && formik.errors.IdOrgVxLocal && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.IdOrgVxLocal}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Tipo de Documento</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('TipoDocumento')}
                    >
                      <option value={''}>Seleccione tipo de documento...</option>
                      {dataTipoDocumento.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select> 
                    {formik.touched.TipoDocumento && formik.errors.TipoDocumento && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.TipoDocumento}</div>
                      </div>
                    )}
                  </div>
                </div>

              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Número de Documento</label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Número de documento'
                      {...formik.getFieldProps('NumDocumento')}
                    />
                    {formik.touched.NumDocumento && formik.errors.NumDocumento && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.NumDocumento}</div>
                      </div>
                    )}
                  </div>
                </div>

              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Dirección</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Dirección'
                      {...formik.getFieldProps('Direccion')}
                    />
                    {formik.touched.Direccion && formik.errors.Direccion && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Direccion}</div>
                      </div>
                    )}
                  </div>
                </div>

              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Ciudad</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Ciudad'
                      {...formik.getFieldProps('Ciudad')}
                    />
                    {formik.touched.Ciudad && formik.errors.Ciudad && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Ciudad}</div>
                      </div>
                    )}
                  </div>
                </div>

                 <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>País</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='País'
                      {...formik.getFieldProps('Pais')}
                    />
                    {formik.touched.Pais && formik.errors.Pais && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Pais}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Tipo de Reclamo</label>
                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('TipoReclamo')}
                    >
                      <option value={''}>Seleccione tipo de Reclamo...</option>
                      {dataTipoReclamo.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}

                    </select>
                    
                    {formik.touched.TipoReclamo && formik.errors.TipoReclamo && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.TipoReclamo}</div>
                      </div>
                    )}
                  </div>
                </div>

              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>
                    Fecha de Incidencia 
                  </label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='date'
                      className={`form-control  ${mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                        } `}
                      // {...formik.getFieldProps('FechaNacimiento')}
                      {...formik.getFieldProps('FechaIncidencia')}
                      value={formik.values.FechaIncidencia} // Formatea la fecha
                      onChange={(e) => {
                        formik.handleChange(e) // Llamar handleChange para manejar cambios
                        formik.setFieldValue('FechaIncidencia', e.target.value) // Actualizar el valor en Formik
                      }}
                    />
                  </div>
                </div>


            <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Detalle</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Detalle'
                      {...formik.getFieldProps('Detalle')}
                    />
                    {formik.touched.Detalle && formik.errors.Detalle && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Detalle}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Pedido</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Pedido'
                      {...formik.getFieldProps('Pedido')}
                    />
                    {formik.touched.Pedido && formik.errors.Pedido && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Pedido}</div>
                      </div>
                    )}
                  </div>
                </div>

              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Tipo de Bien Contratado</label>
                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      {...formik.getFieldProps('TipoBienContratado')}
                    >
                      <option value={''}>Seleccione tipo de Bien Contratado...</option>
                      {dataTipoBienContratado.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                    
                    {formik.touched.TipoBienContratado && formik.errors.TipoBienContratado && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.TipoBienContratado}</div>
                      </div>
                    )}

                  </div>
                </div>
              
              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Padre o Madre</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='PadreOMadre'
                      {...formik.getFieldProps('PadreOMadre')}
                    />
                    {formik.touched.PadreOMadre && formik.errors.PadreOMadre && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.PadreOMadre}</div>
                      </div>
                    )}
                  </div>
                </div>
              
              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Monto de Reclamo</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Monto de Reclamo'
                      {...formik.getFieldProps('MontoReclamo')}
                    />
                    {formik.touched.MontoReclamo && formik.errors.MontoReclamo && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.MontoReclamo}</div>
                      </div>
                    )}
                  </div>
                </div>


              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Descripcion</label>
                  <div className='col-lg-12 fv-row'>
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Descripcion'
                      {...formik.getFieldProps('Descripcion')}
                    />
                    {formik.touched.Descripcion && formik.errors.Descripcion && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Descripcion}</div>
                      </div>
                    )}
                  </div>
                </div>



              <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>
                    Fecha de Respuesta 
                  </label>

                  <div className='col-lg-12 fv-row'>
                    <input
                      type='date'
                      className={`form-control  ${mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                        } `}
                      // {...formik.getFieldProps('FechaNacimiento')}
                      {...formik.getFieldProps('FechaRespuesta')}
                      value={formik.values.FechaRespuesta} // Formatea la fecha
                      onChange={(e) => {
                       formik.handleChange(e) // Llamar handleChange para manejar cambios
                        formik.setFieldValue('FechaRespuesta', e.target.value) // Actualizar el valor en Formik
                      }}
                    />
                  </div>
                </div>


                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Respuesta de Acciones</label>
                  <div className='col-lg-12 fv-row'>
            
                    <input
                      type='text'
                      className={`form-control  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      placeholder='Respuesta de Accion'
                      {...formik.getFieldProps('RespuestaAcciones')}
                    />

                    {formik.touched.RespuestaAcciones && formik.errors.RespuestaAcciones && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.RespuestaAcciones}</div>
                      </div>
                    )}
                  </div>
                </div>
          
                <div className='col-lg-4'>
                  <label className='col-lg-12 col-form-label fw-bold fs-6'>Activo</label>

                  <div className='col-lg-12 fv-row'>
                    <select
                      className={`form-select  ${
                        mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                      } `}
                      value={formik.values.Activo ? 'Si' : 'No'}
                      onChange={(e) => {
                        formik.setFieldValue('Activo', e.target.value === 'Si' ? true : false)
                      }}
                    >
                      <option value={'Si'}>Si</option>
                      <option value={'No'}>No</option>
                    </select>
                    {formik.touched.Activo && formik.errors.Activo && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block fw-bold  mx-3'>{formik.errors.Activo}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row  my-5 me-1'>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              className='btn btn-secondary px-10 me-2 '
              onClick={handleCancelar}
            >
              Cancelar
            </button>
            <button
              type='submit'
              className='btn btn-primary px-10 '
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loadingButton && 'Crear'}
              {loadingButton && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Espere por favor...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export {CreateReclamaciones}
